import { Components } from '@mui/material';

export const DIVIDER: Components['MuiDivider'] = {
  styleOverrides: {
    root: {
      marginLeft: 0
    }
  }
};
